import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import useIsAdmin from '@maxpreps/shared/hooks/useIsAdmin';
import { useIsMobile } from '@maxpreps/shared/hooks/useIsScreenSize';
import THEME, { COLOR } from '@maxpreps/shared/styles/colors';
import Font from '@maxpreps/shared/styles/font';
import StyledCard from '@maxpreps/shared/ui/Card/StyledCard';
import Icon from '@maxpreps/shared/ui/Icon/Icon';
import StyledSeparator from '@maxpreps/shared/ui/Separator/StyledSeparator';
import StyledText from '@maxpreps/shared/ui/Text/StyledText';
import { useState } from 'react';
import styled from 'styled-components';
import { IScheduleCallout } from '../../../utils/schedule/getCalloutInfo';
import AdminOnlyBadge from '../../shared/Admin/AdminOnlyBadge';
import ScheduleCalloutRow from './ScheduleCalloutRow';

const StyledCallout = styled(StyledCard)<{ $isEachCalloutVisible?: boolean }>`
  border: 1px solid ${THEME.status.negative};
  border-radius: 12px;
  padding-bottom: ${props => (props.$isEachCalloutVisible ? '16px' : 0)};
`;

const StyledCalloutHeader = styled.button.attrs({
  type: 'button'
})<{ $isEachCalloutVisible?: boolean }>`
  appearance: none;
  cursor: pointer;
  width: 100%;

  display: flex;
  justify-content: space-between;
  padding: 16px;
  align-items: center;
  white-space: nowrap;
  border-bottom: ${props =>
    props.$isEachCalloutVisible ? `2px solid ${THEME.general.border}` : 'none'};

  background-color: transparent;
  :hover {
    border-radius: ${props =>
      props.$isEachCalloutVisible ? `12px 12px 0 0` : '12px'};

    background-color: ${THEME.surface.tertiary};
  }
`;

const StyledCalloutCount = styled.span<{ $isMobile?: boolean }>`
  background: ${THEME.status.negative};

  border-radius: 50%;
  color: ${COLOR.white};
  display: inline-block;
  line-height: 1.6em;
  text-align: center;
  width: 1.6em;

  font-weight: 600;
  margin-right: 8px;
  font-size: ${props => (props.$isMobile ? '14px' : '16px')};
`;

const StyledRightCalloutContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface IScheduleCalloutsProps {
  scheduleCallouts: IScheduleCallout[];
  isRightRail?: boolean;
}

const ScheduleCallouts: React.FC<IScheduleCalloutsProps> = ({
  scheduleCallouts,
  isRightRail
}) => {
  const isAdmin = useIsAdmin();
  const [isEachCalloutVisible, setIsEachCalloutVisible] = useState(false);
  const isMobile = useIsMobile();

  if (!scheduleCallouts?.length) return null;

  return (
    <StyledCallout $isEachCalloutVisible={isEachCalloutVisible}>
      <StyledCalloutHeader
        onClick={() => setIsEachCalloutVisible(!isEachCalloutVisible)}
        $isEachCalloutVisible={isEachCalloutVisible}
      >
        <div>
          <StyledCalloutCount $isMobile={isMobile}>
            {scheduleCallouts.length}
          </StyledCalloutCount>
          <StyledText
            $color={THEME.status.negative}
            className={isMobile ? Font.f14_bold_tall : Font.f16_bold_tall}
          >
            Games Need Attention
          </StyledText>
        </div>

        <StyledRightCalloutContainer>
          {!isAdmin && (
            <>
              <AdminOnlyBadge />
              <StyledSeparator />
            </>
          )}
          <Icon
            icon={faChevronUp}
            rotation={isEachCalloutVisible ? 180 : 90}
            size={14}
          />
        </StyledRightCalloutContainer>
      </StyledCalloutHeader>
      {isEachCalloutVisible &&
        scheduleCallouts.map(c => (
          <ScheduleCalloutRow
            key={c.contest.contestId}
            callout={c}
            isRightRail={isRightRail}
          />
        ))}
    </StyledCallout>
  );
};

export default ScheduleCallouts;
